import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { ViewTransitionTypes, viewTransition } from "@/utils/view-transitions";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/activity",
)({
	component: RouteComponent,
	beforeLoad: ({ location }) => {
		if (
			location.pathname === "/admin/activity" ||
			location.pathname === "/admin/activity/"
		) {
			throw redirect({
				to: "/admin/activity/logs/orgLogs",
				replace: true,
				...viewTransition(ViewTransitionTypes.FADE),
			});
		}
	},
});

function RouteComponent() {
	return <Outlet />;
}
